import React, { createContext, useContext, useEffect, useState } from 'react';
import { getModules } from '../api/modules';
import { allModules } from '../../modules';

const ModulesContext = createContext(null);

export const ModulesProvider = ({ children }) => {
  const [enabledIds, setEnabledIds] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getModules()
      .then(list => {
        if (cancelled) return;
        setEnabledIds(new Set((list || []).map(m => m.id)));
      })
      .catch(err => {
        if (cancelled) return;
        // /api/modules is permitAll, so this only fails in offline/dev situations.
        // Fall back to every statically-registered module so the UI stays usable.
        console.warn('Failed to load /api/modules; falling back to static module list', err);
        setEnabledIds(new Set(allModules.map(m => m.id)));
        setError(err);
      });
    return () => { cancelled = true; };
  }, []);

  const modules = enabledIds
    ? allModules
        .filter(m => enabledIds.has(m.id))
        .slice()
        .sort((a, b) => a.order - b.order)
    : [];

  return (
    <ModulesContext.Provider value={{ modules, loading: enabledIds === null, error }}>
      {children}
    </ModulesContext.Provider>
  );
};

export const useModules = () => {
  const ctx = useContext(ModulesContext);
  if (!ctx) {
    throw new Error('useModules must be used within a ModulesProvider');
  }
  return ctx;
};
